import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChangeEvent, VirtualScrollComponent } from 'angular2-virtual-scroll';
import { untilComponentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, tap } from 'rxjs/operators';

import { CrisprQueryParameters } from '../../api/crispr.query';
import { ShopListResultDto } from '../../api/listResultDto';
import { CrisprService } from '../crispr.service';
import { defs } from '../../defs';
import { NGXLogger } from 'ngx-logger';
import { CatPartDto } from '../../api/catPartDto';

@Component({
	selector: 'narwhalia-crispr-list',
	templateUrl: './crispr-list.component.html',
	styleUrls: ['./crispr-list.component.scss']
})
export class CrisprListComponent extends OnDestroyMixin implements OnInit {
	@ViewChild(VirtualScrollComponent) private virtualScroll: VirtualScrollComponent;
	buffer: any = [];
	readonly bufferSize: number = 30;
	timer: any;
	loading: boolean;
	scrollItems: CatPartDto[];
	totalCount: number;
	endOfList$: Subject<ChangeEvent>;

	constructor(
		private route: ActivatedRoute,
		private crisprService: CrisprService,
		private log: NGXLogger) {
		super();
		this.endOfList$ = new Subject();
	}

	ngOnInit() {
		this.route.queryParams.subscribe((params: CrisprQueryParameters) => {
			if (!Object.keys(params).some(key => key === 'sortBy')) {
				params = { ...params, sortBy: defs.sortOrders.defaults.crispr };
			}

			this.crisprService.setQueryParams(params);

			this.crisprService.getCrisprImprovements({ ...params, ps: this.bufferSize })
				.subscribe((chunk: ShopListResultDto) => {
					this.buffer = chunk.items;
					this.totalCount = chunk.total;
					this.virtualScroll.scrollToIndex(0, true, 0, 0);
					this.virtualScroll.refresh();
			});
		});

		this.endOfList$
			.pipe(
				distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
				tap(event => this.log.debug('ChangeEvent', event)),
				filter(event => event.end === this.buffer.length - 1 && this.buffer.length < this.totalCount),
				untilComponentDestroyed(this)
			)
			.subscribe(this.fetchMore);
	}

	fetchMore = (event: ChangeEvent) => {
		this.loading = true;
		this.log.trace('=== fetchNextChunk ===');
		this.crisprService
			.getCrisprImprovements({
				...this.crisprService.queryParams.getValue(),
				p: Math.ceil(this.buffer.length / this.bufferSize),
				ps: this.bufferSize
			})
			.subscribe((chunk: ShopListResultDto) => {
				this.buffer = this.buffer.concat(chunk.items);
				this.loading = false;
			}, () => (this.loading = false));
	};
}